import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/ljtong.png'


const _withScopeId = n => (_pushScopeId("data-v-52e61c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectGoods = _resolveComponent("ProjectGoods")!
  const _component_FreeGoods = _resolveComponent("FreeGoods")!
  const _component_VideoGoods = _resolveComponent("VideoGoods")!
  const _component_PartsGoods = _resolveComponent("PartsGoods")!
  const _component_Mask = _resolveComponent("Mask")!
  const _component_Delete = _resolveComponent("Delete")!

  return (_openBlock(), _createElementBlock("div", {
    class: "goods-info",
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.leaving(_ctx.step)))
  }, [
    (_ctx.collectionType == 1)
      ? (_openBlock(), _createBlock(_component_ProjectGoods, {
          key: 0,
          goods: _ctx.goods
        }, null, 8, ["goods"]))
      : _createCommentVNode("", true),
    (_ctx.collectionType == 2)
      ? (_openBlock(), _createBlock(_component_FreeGoods, {
          key: 1,
          goods: _ctx.goods
        }, null, 8, ["goods"]))
      : _createCommentVNode("", true),
    (_ctx.collectionType == 3)
      ? (_openBlock(), _createBlock(_component_VideoGoods, {
          key: 2,
          goods: _ctx.goods
        }, null, 8, ["goods"]))
      : _createCommentVNode("", true),
    (_ctx.collectionType == 4)
      ? (_openBlock(), _createBlock(_component_PartsGoods, {
          key: 3,
          goods: _ctx.goods
        }, null, 8, ["goods"]))
      : _createCommentVNode("", true),
    (_ctx.step == 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "qunfengshanchuchong",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickDelete(1)))
        }, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["mengceng", { mask: _ctx.step == 1, 'edit-delete': _ctx.step == 2 }])
    }, [
      (_ctx.step == 1)
        ? (_openBlock(), _createBlock(_component_Mask, {
            key: 0,
            showDelete: _ctx.showDelete,
            mindex: _ctx.mindex,
            onOneClickDelete: _ctx.oneClickDelete
          }, null, 8, ["showDelete", "mindex", "onOneClickDelete"]))
        : _createCommentVNode("", true),
      (_ctx.step == 2)
        ? (_openBlock(), _createBlock(_component_Delete, {
            key: 1,
            isselect: _ctx.goods.isselect,
            mindex: _ctx.mindex
          }, null, 8, ["isselect", "mindex"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 32))
}